export function StarFilled(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.33098 6.4L8.86751 2.28429C9.30856 1.10215 10.6234 0.501412 11.8037 0.946563C12.42 1.17896 12.9054 1.66703 13.1357 2.28452L14.67 6.4L18.9219 6.40092C20.1292 6.40111 21.1147 7.34175 21.1947 8.52913L21.2 8.68535C21.2 9.39229 20.8734 10.0598 20.3531 10.4616L17.177 13.135L19.041 18.1159C19.4615 19.2438 18.9356 20.4961 17.8588 20.9912L17.7085 21.0539C17.0209 21.3131 16.251 21.2239 15.6404 20.8147L15.5239 20.7258L11.001 16.818L6.47977 20.7256L6.36327 20.8145C5.31478 21.5173 3.89713 21.2322 3.19952 20.1801C2.79479 19.5698 2.70685 18.8019 2.96195 18.1178L4.78998 13.185L1.68395 10.4916C0.735629 9.75581 0.525434 8.41836 1.17426 7.43068L1.27281 7.29207C1.70382 6.73056 2.37065 6.40103 3.07815 6.40092L7.33098 6.4Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
